import en from './en.js';
import ja from './ja.js';

const messages = {
  en,
  ja
};

export default messages;



// WEBPACK FOOTER //
// ./src/lang/about/index.js